import { environment } from '~env/environment';

export const AKAMAI_BASE_URL = () => environment.akamaiBaseUrl();
export const AKAMAI_PP_BASE_URL = 'https://images.pp.metro-marketplace.eu'

export const AKAMAI_POLICIES = {
    TOP_NAVIGATION_CATEGORY_BUBBLE: 'top-navigation_category-bubble'
}
